<template>
  <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    <div class="bg-white dark:bg-dark-modal dark:text-dark-text  p-6 rounded-lg shadow-lg max-w-xl w-full relative" @keyup.esc="closePopup">
      <button @click="closePopup"
              class="absolute text-3xl top-4 right-5 w-10 text-gray-600 hover:text-gray-900 dark:text-dark-text">
        &times;
      </button>
      <h2 class="text-xl font-semibold mb-4">Story Details</h2>
      <hr/>

      <div class="flex items-start mb-4 flex-1 mt-4">
        <div class="text-sm font-medium text-gray-700 w-1/4 dark:text-dark-text">Title:</div>
        <div class="text-md font-medium text-gray-700 w-3/4 dark:text-dark-text">
           <span v-if="story.label || story.label_color"
                 class="me-2 text-xs border p-1 rounded inline-flex items-center"
                 :style="`background:${story.label_color}; border-color:${story.label_color}; color:${getTextColor(story.label_color)}`">
              {{ story.label ?? ' ' }}
            </span>
          {{ story?.title }}
        </div>
        <a :href="story.url" v-if="story.url"
           title="Story Link"
           target="_blank" class="flex me-2 text-blue-300">
          <URLIcon title="Story Link"/>
        </a>
      </div>

      <div class="flex items-start mb-4 flex-1">
        <div class="text-sm font-medium text-gray-700 w-1/4 dark:text-dark-text">Description:</div>
        <div class="text-md font-medium text-gray-700 w-3/4 dark:text-dark-text">{{ story?.note }}</div>
      </div>

      <div class="flex items-center mb-4 flex-1">
        <div class="text-sm font-medium text-gray-700 w-1/4 dark:text-dark-text">Estimated:</div>
        <div class="text-md font-medium text-blue-700 w-3/4 dark:text-dark-text">{{
            getCardLabel(story.estimated)
          }}
        </div>
      </div>

      <div class="flex items-center mb-4 flex-1">
        <div class="text-sm font-medium text-gray-700 w-1/4 dark:text-dark-text">Created At:</div>
        <div class="text-md font-medium text-gray-700 w-3/4 dark:text-dark-text">{{ createdAt }}</div>
      </div>

      <div class="flex items-center mb-4 flex-1">
        <div class="text-sm font-medium text-gray-700 w-1/4 dark:text-dark-text">Started At:</div>
        <div class="text-md font-medium text-gray-700 w-3/4 dark:text-dark-text">{{ startedAt }}</div>
      </div>

      <div class="flex items-center mb-4 flex-1" v-if="story.skipped_at">
        <div class="text-sm font-medium text-gray-700 w-1/4 dark:text-dark-text">Skipped At:</div>
        <div class="text-md font-medium text-gray-700 w-3/4 dark:text-dark-text">{{ duration(story.skipped_at) }}</div>
      </div>

      <div class="flex items-center mb-4 flex-1" v-else>
        <div class="text-sm font-medium text-gray-700 w-1/4 dark:text-dark-text">Completed In:</div>
        <div class="text-md font-medium text-gray-700 w-3/4 dark:text-dark-text">
          {{ duration(story?.completed_at || story?.closed_at) }}
        </div>
      </div>

      <hr/>
      <div class="flex items-start mb-4 flex-1 justify-start mt-6">
        <div class="text-md font-medium text-gray-700 w-full flex flex-col  dark:text-dark-text">
          <table class="table w-full">
            <thead>
            <tr class="bg-gray-200 border-b border-gray-300 dark:bg-dark-g400 dark:border-dark-border">
              <td class="p-2">Player</td>
              <td class="p-2 text-center">Vote</td>
              <td class="p-2 text-center">Duration</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(estimate, index) in estimates" :key="`player-${index}`"
                class="border-b border-gray-200 hover:bg-blue-50 dark:border-dark-border dark:hover:bg-dark-gray">
              <td class="p-2">{{ getPlayerName(estimate?.player_id) }}</td>
              <td class="text-center">
                <span class="p-2 font-bold text-blue-500 dark:text-dark-text">{{ getCardLabel(estimate.score) }}</span>
              </td>
              <td class="text-center">
                <span class="p-2 text-gray-500  dark:text-dark-text">{{ duration(estimate.estimated_at) }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br>
      <div class="flex gap-4 mt-6">
        <Button variant="primary" @click="closePopup" title="Close"/>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import Cards from "@/library/cards";
import Colors from "@/library/colors";
import Utils from "@/library/utils";
import RoomStore from '@/store/room';
import URLIcon from '@/assets/url';

export default {
  emits: ['closeDetails'],
  components: {
    Button,
    URLIcon
  },
  props: {
    story: Object
  },

  computed: {
    estimates() {
      return this.story?.estimates || [];
    },

    createdAt() {
      return Utils.formatDateTime(this.story.created_at);
    },

    startedAt() {
      return Utils.formatDateTime(this.story.started_at);
    },
  },
  methods: {
    getTextColor(color) {
      return Colors.getOppositeColor(color)
    },
    getPlayerName(playerId) {
      return RoomStore.players.find(p => p.user_id === playerId)?.user?.username
    },

    getCardLabel(id) {
      return Cards.find(i => i.id === id)?.value || ''
    },

    duration(endTime) {
      const startTime = this.story?.started_at;

      if (!startTime || !endTime) {
        return '-';
      }

      const elapsedMilliseconds = new Date(startTime) - new Date(endTime);
      return Utils.getFormattedTime(Math.floor(Math.abs(elapsedMilliseconds) / 1000));
    },

    closePopup() {
      this.$emit('closeDetails')
    },
  }
};
</script>
